import { IconProps } from '../Icon';
import { TextProps } from '../Text';


type ButtonInternalProps = {
  icon?: IconProps;
  text?: TextProps;
};

type ButtonPropsValues = {
  'ComponentIconSDestructiveDefault': ButtonInternalProps;
  'ComponentIconSPositiveDefault': ButtonInternalProps;
  'CopyIconSPrimarySubduedDefault': ButtonInternalProps;
  'FieldIconSDarkDefault': ButtonInternalProps;
  'FieldIconSDarkSelected': ButtonInternalProps;
  'FieldIconSPrimaryDefault': ButtonInternalProps;
  'FieldIconSPrimarySelected': ButtonInternalProps;
  'IconNoBGSPrimaryDefault': ButtonInternalProps;
  'IconMPrimarySubduedDefault': ButtonInternalProps;
  'IconSPrimarySubduedDefault': ButtonInternalProps;
  'IconTextNoBGSPrimaryLightDefault': ButtonInternalProps;
  'IconTextNoBGSPrimaryDefault': ButtonInternalProps;
  'IconTextMPrimaryOutlineLoaded': ButtonInternalProps;
  'IconTextMPrimaryOutlineLoading': ButtonInternalProps;
  'IconTextMPrimarySubduedDefault': ButtonInternalProps;
  'IconTextMPrimarySubduedLoading': ButtonInternalProps;
  'TextIconMPrimaryDefault': ButtonInternalProps;
  'TextIconSPrimaryDefault': ButtonInternalProps;
  'TextIconSPrimarySubduedDefault': ButtonInternalProps;
  'TextNoBGSPrimaryDefault': ButtonInternalProps;
  'TextLDestructiveDefault': ButtonInternalProps;
  'TextLPrimaryDefault': ButtonInternalProps;
  'TextLPrimaryLoaded': ButtonInternalProps;
  'TextLPrimaryLoading': ButtonInternalProps;
  'TextLPrimarySubduedDefault': ButtonInternalProps;
  'TextMDestructiveDefault': ButtonInternalProps;
  'TextMDestructiveSubduedDefault': ButtonInternalProps;
  'TextMPrimaryDefault': ButtonInternalProps;
  'TextMPrimaryLoaded': ButtonInternalProps;
  'TextMPrimaryLoading': ButtonInternalProps;
  'TextMPrimarySubduedDefault': ButtonInternalProps;
  'TextSPrimaryDefault': ButtonInternalProps;
  'TextSPrimaryLoaded': ButtonInternalProps;
  'TextSPrimaryLoading': ButtonInternalProps;
  'TextSPrimarySubduedDefault': ButtonInternalProps;
  'TextSPrimarySubduedLoaded': ButtonInternalProps;
  'TextSPrimarySubduedLoading': ButtonInternalProps;
  'TextUnderlineSPrimaryDefault': ButtonInternalProps;
  'IconTextMPrimarySubduedLoaded': ButtonInternalProps;
  'FieldIconSPositiveDefault': ButtonInternalProps;
  'FieldIconSPositiveSelected': ButtonInternalProps;
};

const propValues: ButtonPropsValues = {
  'ComponentIconSDestructiveDefault': {
    icon: {
      asset: 'Close',
      colour: 'IconDestructive',
    },
  },
  'ComponentIconSPositiveDefault': {
    icon: {
      asset: 'Close',
      colour: 'IconPositiveHover',
    },
  },
  'CopyIconSPrimarySubduedDefault': {
    icon: {
      asset: 'Copy',
      colour: 'IconPrimary',
    },
  },
  'FieldIconSDarkDefault': {
    icon: {
      asset: 'Close',
      colour: 'IconDark',
    },
  },
  'FieldIconSDarkSelected': {
    icon: {
      asset: 'Close',
      colour: 'IconDark',
    },
  },
  'FieldIconSPrimaryDefault': {
    icon: {
      asset: 'Close',
      colour: 'IconPrimary',
    },
  },
  'FieldIconSPrimarySelected': {
    icon: {
      asset: 'Close',
      colour: 'IconPrimary',
    },
  },
  'IconNoBGSPrimaryDefault': {
    icon: {
      asset: 'CardMenu',
      colour: 'IconPrimary',
    },
  },
  'IconMPrimarySubduedDefault': {
    icon: {
      asset: 'Back',
      colour: 'IconPrimary',
    },
  },
  'IconSPrimarySubduedDefault': {
    icon: {
      asset: 'CardMenu',
      colour: 'IconPrimary',
    },
  },
  'IconTextNoBGSPrimaryLightDefault': {
    icon: {
      asset: 'Plus',
      colour: 'IconLight',
    },
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Light',
      type: 'Button1',
    },
  },
  'IconTextNoBGSPrimaryDefault': {
    icon: {
      asset: 'Plus',
      colour: 'IconPrimary',
    },
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
  },
  'IconTextMPrimaryOutlineLoaded': {
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconPrimary',
    },
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
  },
  'IconTextMPrimaryOutlineLoading': {
    icon: {
      asset: 'Loading',
      colour: 'IconPrimary',
    },
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
  },
  'IconTextMPrimarySubduedDefault': {
    icon: {
      asset: 'Plus',
      colour: 'IconPrimary',
    },
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
  },
  'IconTextMPrimarySubduedLoading': {
    icon: {
      asset: 'Loading',
      colour: 'IconPrimary',
    },
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
  },
  'TextIconMPrimaryDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Light',
      type: 'Button1',
    },
    icon: {
      asset: 'Plus',
      colour: 'IconLight',
    },
  },
  'TextIconSPrimaryDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Light',
      type: 'Button1',
    },
    icon: {
      asset: 'Plus',
      colour: 'IconLight',
    },
  },
  'TextIconSPrimarySubduedDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
    icon: {
      asset: 'Plus',
      colour: 'IconPrimary',
    },
  },
  'TextNoBGSPrimaryDefault': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
  },
  'TextLDestructiveDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Light',
      type: 'Button2',
    },
  },
  'TextLPrimaryDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Light',
      type: 'Button2',
    },
  },
  'TextLPrimaryLoaded': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button2',
    },
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconPrimary',
    },
  },
  'TextLPrimaryLoading': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button2',
    },
    icon: {
      asset: 'Loading',
      colour: 'IconPrimary',
    },
  },
  'TextLPrimarySubduedDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button2',
    },
  },
  'TextMDestructiveDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Light',
      type: 'Button1',
    },
  },
  'TextMDestructiveSubduedDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Destructive',
      type: 'Button1',
    },
  },
  'TextMPrimaryDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Light',
      type: 'Button1',
    },
  },
  'TextMPrimaryLoaded': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconPrimary',
    },
  },
  'TextMPrimaryLoading': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
    icon: {
      asset: 'Loading',
      colour: 'IconPrimary',
    },
  },
  'TextMPrimarySubduedDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
  },
  'TextSPrimaryDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Light',
      type: 'Button1',
    },
  },
  'TextSPrimaryLoaded': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconPrimary',
    },
  },
  'TextSPrimaryLoading': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
    icon: {
      asset: 'Loading',
      colour: 'IconPrimary',
    },
  },
  'TextSPrimarySubduedDefault': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
  },
  'TextSPrimarySubduedLoaded': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Light',
      type: 'Button1',
    },
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconPrimary',
    },
  },
  'TextSPrimarySubduedLoading': {
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Light',
      type: 'Button1',
    },
    icon: {
      asset: 'Loading',
      colour: 'IconPrimary',
    },
  },
  'TextUnderlineSPrimaryDefault': {
    text: {
      align: 'Left',
      styleType: 'Medium',
      colour: 'InteractiveUnderline',
      type: 'Button1',
    },
  },
  'IconTextMPrimarySubduedLoaded': {
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconPrimary',
    },
    text: {
      align: 'Center',
      styleType: 'Medium',
      colour: 'Interactive',
      type: 'Button1',
    },
  },
  'FieldIconSPositiveDefault': {
    icon: {
      asset: 'Close',
      colour: 'IconPrimary',
    },
  },
  'FieldIconSPositiveSelected': {
    icon: {
      asset: 'Close',
      colour: 'IconPrimary',
    },
  },
};

const getProps = (type: string): ButtonInternalProps => {
  const values: ButtonInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
